import { templates } from './templates';
import { mainmenu, emplmenu } from './menu';
import { colors, colorsList, colorsList2 } from './colors';
import { drawerWidth } from './sizes';
import * as yup from './yupSchemas';
import {
  statusTypes,
  eventStatusEn,
  eventStatus,
  paymentTypes,
  carstatuss,
} from './datatypes';
import { operationTypes, catTypes } from './datatypes';
import { packages } from './roles';

export const burl = 'alsardal';

export const graphqlURI = `https://${burl}.jadwal.io/graphql`;
export const wsURI = `wss://${burl}.jadwal.io/graphql`;

// export const graphqlURI = 'http://localhost/graphql';
// export const wsURI = 'ws://localhost/graphql';

// demos kafu limitless lueur shamsdoha smartvision vision web hotspot speedtime innovation shine hytara mkgroup demo2 almenasah hydra twentyone alsardal

export const notURI = `https://${burl}.jadwal.io`;
export const appversion = '2.03';
export {
  mainmenu,
  emplmenu,
  catTypes,
  colors,
  colorsList,
  colorsList2,
  yup,
  drawerWidth,
  statusTypes,
  eventStatusEn,
  eventStatus,
  operationTypes,
  paymentTypes,
  templates,
  packages,
  carstatuss,
};
